/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './bug-request-dialog/bug-request-dialog.component';
export * from './bug-request-dialog/bug-request-dialog-dialog.route';
// export * from "./bug-request-dialog/bug-request-dialog.route";
